import React from "react";
import { Gallery } from "devextreme-react/gallery";

const ads = [
  { image: "/images/001.jpg", alt: "Ad 1" },
  { image: "/images/002.jpg", alt: "Ad 2" },
  { image: "/images/003.jpg", alt: "Ad 3" },
];

const AdRotator = () => {
  return (
    <Gallery
      dataSource={ads}
      height={400}  // ✅ Fixed height to 250px
      width={"100%"}  // ✅ Full width
      showNavButtons={true}
      showIndicator={true}
      slideshowDelay={5000} // Auto-rotate every 3 seconds
      loop={true}
      stretchImages={true} // ✅ Ensures images fit properly
      itemRender={(item) => (
        <img
          src={item.image}
          alt={item.alt}
          className="w-full h-full object-fill"//"w-full h-full object-cover rounded-lg"
          style={{ 
            minHeight:400,
            minWidth:700
          }}
        />
      )}
    />
  );
};

export default AdRotator;
